/**
 * Filtros que muestra "Más filtros" cuando el usuario no eligió ninguno en
 * "Select filter fields". Lo usan Filters.vue (para dibujarlos) y el listado
 * (para que el selector los muestre tildados): así tildar un filtro más lo suma
 * a los que ya se veían, en vez de dejar solo ese.
 */

const DEFAULT_FILTER_FIELD_KEYS = ["name", "idModel", "createdAt", "updatedAt"];
const DEFAULT_FILTER_FIELD_TYPES = ["string", "number", "date"];
/** De cada grupo se ofrecen los primeros campos, no todos. */
const DEFAULT_GROUP_SUBFIELDS = 3;

/** ¿El campo (no grupo) está entre los filtros por defecto? */
export function isDefaultFilterField(field) {
  if (!field || field.type === "group") return false;
  // Los filtros de módulo (p. ej. "Saldo al") se eligen a mano; no aparecen solos.
  if (field.isModuleFilter) return false;
  return (
    DEFAULT_FILTER_FIELD_KEYS.includes(field.key) ||
    DEFAULT_FILTER_FIELD_TYPES.includes(field.type)
  );
}

/** Subcampos de un grupo que entran por defecto. */
export function defaultGroupFilterSubFields(groupField) {
  const subFields = Array.isArray(groupField && groupField.fields)
    ? groupField.fields
    : [];
  return subFields
    .slice(0, DEFAULT_GROUP_SUBFIELDS)
    .filter((subField) => subField && subField.type !== "group");
}

/** Los filtros por defecto como selección (`{ clave: true }`), igual que "Select filter fields". */
export function defaultFilterFieldSelection(modelFields) {
  const selection = {};
  (modelFields || []).forEach((field) => {
    if (!field) return;
    if (field.type === "group") {
      defaultGroupFilterSubFields(field).forEach((subField) => {
        selection[`${field.key}.${subField.key}`] = true;
      });
    } else if (isDefaultFilterField(field)) {
      selection[field.key] = true;
    }
  });
  return selection;
}
